import src from "IMAGE";
export default { src, width: 800, height: 344, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAASElEQVR42hXJsQ2AMAwAwQwDBENN3OIdkBAdwgvBEPGcvK/54suCiOju/ojInG505CsDPlyotU7pxIsRxcz2DdQOZFW1rWj4AdihG/MPTM62AAAAAElFTkSuQmCC"};
